export const login = {
    "login_building_title": "Iniciar sesión a la cuenta del edificio",
    "login_building_sub_title": "Iniciar sesión en la cuenta del edificio te permitirá controlar y administrar los pagos del edificio y ver fácilmente los recibos de los inquilinos.",
    "forgot_password": "¿Olvidaste tu contraseña?",
    "login_with": "Iniciar sesión con",
    "open_account": "Abrir cuenta",
    "login_to_account": "Iniciar sesión",
    "logout": "Cerrar sesión",
    "hi": "Hola, {{firstName}}",
    "facebook": "Facebook",
    "google": "Google",
    "login_generic_error": "Ocurrió un error al iniciar sesión. Verifica el nombre de usuario y la contraseña.",
    "reset_password_sub_title": "Nos alegra que se haya unido a nuestro nuevo sistema. Para iniciar sesión, seleccione una contraseña segura y recuérdela para futuros inicios de sesión",
    "reset_password_sub_explain": "Inmediatamente después de seleccionar la nueva contraseña, será dirigido nuevamente a la página principal para iniciar sesión con la nueva contraseña.",
    "new_password": "Nueva contraseña",
    "new_password_again": "Repita su nueva contraseña",
    "reset_password": "Cambio de contraseña",
    "not_working_on_mobile": "Estimado Gerente, lamentablemente el enlace aún no está disponible para usted desde su móvil",
    "only_maintenance_on_mobile": "Estimado gerente, el inicio de sesión móvil solo es compatible con los gerentes de mantenimiento todavía",
    "must_contain": "La contraseña debe contener:",
    "small_letter": "Una letra minúscula en inglés",
    "capital_letter": "Una letra mayúscula en inglés",
    "number": "Número",
    "8_digits": "Al menos 8 dígitos",
    "same_passwords": "Las 2 contraseñas ingresadas son las mismas"
};
